export default __webpack_public_path__ + "static/media/progress.c7b65c3b.png";